import { withPrefix } from 'gatsby'
import React from 'react'
import * as Styles from './security.module.scss'
import { Contact } from '@/components/general/contact'
import { Layout } from '@/components/general/layout'
import { PageTitle } from '@/components/general/page-title'
import { Seo } from '@/components/general/seo'

const SecurityPage = ({ location }) => (
  <Layout location={location}>
    <Seo
      title="セキュリティについて"
      description="クラウド決算開示管理サービス【Uniforce】のセキュリティに関する取り組みについて。データの暗号化、WAFno導入、サーバーレスアーキテクチャの採用、脆弱性検査、データベースセキュリティの最大化、Cognito Authorizerの採用。"
    />

    <PageTitle
      title="セキュリティについて"
      en="SECURITY"
      className={Styles.pageTitle}
      decorationLogo
    />

    {/* 社名変更による再審査のため非表示 */}
    {/* <section className={Styles.isoBoxSection}>
      <div className={Styles.isoBoxSection__container}>
        <h2 className={Styles.sectionTitle}>組織的な対策</h2>
        <div className={Styles.isoBox}>
          <div className={Styles.isoBox__image}>
            <StaticImage src="../images/security_iso.jpg" height={135} />
          </div>
          <div className={Styles.isoBox__text}>
            <h3>ISO 27001（ISMS）を取得</h3>
            <p>
              Uniforceは、情報セキュリティマネジメントシステムに関する国際標準規格「ISO27001（ISMS）」の認証を2022年3月29日に取得。定期的に開催される取締役会およびISMSマネジメントレビューによって、内部統制の整備と監督を行っており、情報の機密性・完全性・可用性の維持、改善に日々取り組んでいます。
            </p>
          </div>
        </div>
      </div>
    </section> */}

    <section className={Styles.technicalSection}>
      <h2 className={Styles.sectionTitle}>技術的な対策</h2>
      <ul className={Styles.technicalList}>
        <li>
          <img src={withPrefix('/security_icon_1.svg')} alt="" width={86.93} height={85.54} />
          <dl>
            <dt>通信の安全化（SSL）</dt>
            <dd>
              ブラウザとサーバー間のデータ通信を暗号化します。暗号化通信により、サイト利用ユーザーの個人情報やログイン情報を、第三者の盗聴から守り、改ざんやなりすましから個人情報を保護します。
            </dd>
          </dl>
        </li>
        <li>
          <img src={withPrefix('/security_icon_2.svg')} alt="" width={86.44} height={73.45} />
          <dl>
            <dt>WAFの導入</dt>
            <dd>
              ウェブの脆弱性を利用した攻撃やボットから、アプリケーションやAPIを保護するために、AWS
              WAFを採用しています。サイバーセキュリティクラウド社のWafCharmを適用し、独自にカスタマイズしたルールを構築、運用しています。
            </dd>
          </dl>
        </li>
        <li>
          <img src={withPrefix('/security_icon_3.svg')} alt="" width={87.09} height={76.36} />
          <dl>
            <dt>
              サーバーレス
              <br className="lg" />
              アーキテクチャの採用
            </dt>
            <dd>
              サーバーを持たないため、OSやソフトウェアの脆弱性対応などが不要となり、常にAWSが最新の状態に保たれ、セキュリティリスクが低減されます。
            </dd>
          </dl>
        </li>
        <li>
          <img src={withPrefix('/security_icon_4.svg')} alt="" width={88.96} height={69.31} />
          <dl>
            <dt>脆弱性検査</dt>
            <dd>
              リリース前にGSX<sup>※</sup>
              のタイガーチームによる大規模なペネトレーションテストを実施し、定期的な診断を実施しています。悪意ある攻撃や情報漏えい事故などのリスクを未然に防ぐことができます。
            </dd>
          </dl>
          <p className={Styles.caution}>
            <small>
              ※GSX…グローバルセキュリティエキスパート株式会社　
              <a
                href="https://www.gsx.co.jp/"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.gsx.co.jp/
              </a>
            </small>
          </p>
        </li>
        <li>
          <img src={withPrefix('/security_icon_5.svg')} alt="" width={84.21} height={89.16} />
          <dl>
            <dt>
              データベース
              <br className="lg" />
              セキュリティの最大化
            </dt>
            <dd>
              データベースへのアクセスをIAM認証による暗号通信とすることでセキュリティを担保しています。さらにデータベース自身も非公開領域(Private-Subnet)
              に配置し、情報漏えいを防止しています。
            </dd>
          </dl>
        </li>
        <li>
          <img src={withPrefix('/security_icon_6.svg')} alt="" width={84.21} height={66.55} />
          <dl>
            <dt>Cognito Authorizerの採用</dt>
            <dd>
              ユーザーのログイン認証でも利用しているAmazon
              Cognitoと連携するCognito Authorizer をAPI Gatewayに適用し、API
              Gateway の不正利用を防ぐことでセキュリティ強化を実現しています。
            </dd>
          </dl>
        </li>
      </ul>
    </section>

    <Contact />
  </Layout>
)

export default SecurityPage
